import { GenericAbortSignal } from 'axios';

import { BASE_URL, S3_URL } from '../constants';
import { get, post } from '../requestMethods';
import { SummarizeRequestData } from './types';

const URL = `${BASE_URL}/api/tools`;

export const OTHER_CALLS_API = {
  // Get rewritten text with ChatGPT
  rewriteTextWithChatGPT: (data: SummarizeRequestData, signal: GenericAbortSignal) =>
    post<{
      text: string;
    }>(`${URL}/summarize`, { data, signal }),
  getS3Data: <T>(path: string) => get<T>(`${S3_URL}${path}`),
};
